import React from "react";

function WhyChoose() {
  return (
    <section
      className="why_choose_us pt_150 about_page"
      data-aos="fade-up"
      data-aos-easing="linear"
      data-aos-duration="500"
    >
      <div className="shape_circle float-bob-y">
        <img src="/images/icons/ring_shape.png" alt="Ring Shape" />
      </div>

      <div className="container">
        <div className="border_top"></div>
        <div className="section_title centred">
          <h2>Why Choose us</h2>
          <p>
            Eco Mantra Capital combines innovation and reliability to give you
            the best financial technology experience.
          </p>
        </div>

        <div className="row">
          {/* Bank-Grade Security */}
          <div className="col-xl-3 col-md-6 col-sm-12">
            <div
              className="why_choose_block_two mb_40"
              data-aos="fade-right"
              data-aos-easing="linear"
              data-aos-duration="500"
              data-aos-delay="100"
            >
              <div className="choose_icon">
                <i className="fa-solid fa-shield-halved"></i>
              </div>
              <h4>Bank-Grade Security</h4>
              <p>
                We ensure all transactions and data are protected with
                enterprise-level encryption and compliance standards.
              </p>
            </div>
          </div>

          {/* Lightning-Fast Solutions */}
          <div className="col-xl-3 col-md-6 col-sm-12">
            <div
              className="why_choose_block_two mb_40"
              data-aos="fade-right"
              data-aos-easing="linear"
              data-aos-duration="500"
              data-aos-delay="200"
            >
              <div className="choose_icon">
                <i className="fa-solid fa-bolt"></i>
              </div>
              <h4>Lightning-Fast Solutions</h4>
              <p>
                Optimized infrastructure to process payments and transactions at
                unmatched speed and reliability.
              </p>
            </div>
          </div>

          {/* Global Reach */}
          <div className="col-xl-3 col-md-6 col-sm-12">
            <div
              className="why_choose_block_two mb_40"
              data-aos="fade-right"
              data-aos-easing="linear"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <div className="choose_icon">
                <i className="fa-solid fa-earth-africa"></i>
              </div>
              <h4>Global Reach</h4>
              <p>
                Our fintech solutions are scalable and compliant with
                international standards for worldwide operations.
              </p>
            </div>
          </div>

          {/* 24/7 Dedicated Support */}
          <div className="col-xl-3 col-md-6 col-sm-12">
            <div
              className="why_choose_block_two mb_40"
              data-aos="fade-right"
              data-aos-easing="linear"
              data-aos-duration="500"
              data-aos-delay="400"
            >
              <div className="choose_icon">
                <i className="fa-solid fa-headset"></i>
              </div>
              <h4>24/7 Support</h4>
              <p>
                A team of experts always ready to assist you, ensuring smooth
                financial operations round the clock.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChoose;
